import axios from 'axios'
import { requestSuccess } from '#src/interceptors/dmInterceptor'

const axiosInstance = axios.create()

const defaultErrorHandler = (error: unknown) => Promise.reject(error)

axiosInstance.interceptors.request.use(requestSuccess, defaultErrorHandler)

export default axiosInstance
